<template>
  <a-modal
    title="groovy增强"
    :width="modalWidth"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;height: 95%;">

    <a-form style="height: 100%;">
      <j-code-editor
        ref="codeEditor"
        :value="cgGroovy"
        language="java"
        :fullScreen="true"
        :lineNumbers="false"
        @input="handleCodeChange"
        :min-height="240"
        :language-change="false"></j-code-editor>
    </a-form>

    <template slot="footer">
      <a-button key="back" @click="handleCancel">关闭</a-button>
      <a-button key="submit" type="primary" @click="handleSubmit">确定</a-button>
    </template>

    <enhance-history ref="historyModal"></enhance-history>
  </a-modal>
</template>

<script>
  import { postAction,getAction,putAction } from '@/api/manage'
  import EnhanceHistory from './EnhanceHistory'
  import { AiTestOnlineMixin } from '@/views/modules/aitest/onlinetest.mixins'

  export default {
    name: 'EnhanceGroovy',
    components: { EnhanceHistory },
    mixins:[AiTestOnlineMixin],
    data(){
      return {
        modalWidth:800,
        visible:false,
        confirmLoading:false,
        form:this.$form.createForm(this),
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        url:'/online/cgform/head/enhanceGroovy/',
        model:{},
        cgJsType:[],
        cgGroovy:'',
        code:'',
        validError: false,
        showHistory: false,
        codeChange: false,
        tableName: ''
      }
    },
    methods:{
      handleSubmit(){
        this.validError = false
        let formData = {
          cgGroovy:this.$refs.codeEditor.getCodeContent(),
        }
        let promiseForm;
        console.log("model",this.model)
        if(!this.model.id){
          promiseForm = postAction(this.url+this.code,formData)
        }else{
          let updateFormData = Object.assign({},this.model,formData)
          promiseForm = putAction(this.url+this.code,updateFormData)
        }
        promiseForm.then(res=>{
          this.confirmLoading = false;
          if(res.success){
            this.addLocalRecord(formData);
            this.visible = false
            this.$message.success(res.message)
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      handleCancel(){
        this.visible = false
      },
      show(row){
        let code = row.id
        let def = `/*参数说明 json:表单数据, map里需要放入拼好的sql语句 */
functioin exec(json,map){}
        `
        this.validError = false
        this.codeChange = false
        this.code = code
        this.tableName = row.tableName
        let that = this
        getAction(`/online/cgform/head/enhanceGroovy/${code}`).then(res=>{
          let item = res.result || {}
          let cgGroovy = item.cgGroovy || def
          if(this.$refs.codeEditor){
              this.$refs.codeEditor.setCodeContent(cgGroovy)
          }else{
            that.cgGroovy = cgGroovy
          }
          that.model = item
          that.visible=true
        })
        
      },
      addLocalRecord(formData){
        if(this.codeChange === true){
          let record = {
            code: this.code,
            str: formData.cgGroovy,
            type: formData.cgJsType,
            date: new Date().getTime()
          }
          this.$store.dispatch("addEhanceRecord",record);
        }
      },
      handleWatchHistory(){
        this.$refs.historyModal.show(this.code, this.cgJsType)
      },
      handleCodeChange(value){
        if(this.cgGroovy != value){
          this.codeChange = true
          this.cgGroovy = value
        }

      }
    }
  }

</script>

<style scoped>
  .js-type-select{
    position:absolute;
    z-index:10;
    right:58px;
    top:80px;
    max-width:146px;
  }
</style>